import React, { useEffect, useState } from 'react';
import useMsalApi from '../../components/use-msal-api';
import {TextInput,TableHeader,Table,TableRow,TableHead,TableCell,TableBody, Tabs,Tab} from 'carbon-components-react';

const OpenEnrollmentList = () => {
    
const [completedEmployees, setCompletedEmployees] = useState();
const [completedFilteredEmployees,setCompletedFilteredEmployees] = useState();
const [activeEmployees, setActiveEmployees] = useState();
const [activeFilteredEmployees,setActiveFilteredEmployees] = useState();
const [percentComplete,setPercentComplete] = useState();
const [numberComplete,setNumberComplete] = useState();
const completedHeaders = ['Employee Name', 'Employee ID'];
const activeHeaders = ['Employee Name', 'Employee ID'];
const [callApi] = useMsalApi();

useEffect(() => {
    getEmployees();
}, [])

const getEmployees = async () => {
    const results = await callApi("Enrollments/OpenEnrollmentReport", "GET");
    if(!results.error){
        setCompletedEmployees(results.enrolled);
        setCompletedFilteredEmployees(results.enrolled);
        setActiveFilteredEmployees(results.active);
        setNumberComplete(results.enrolled.length);
        setPercentComplete(results.percentage);
        setActiveEmployees(results.active);
    }
}


    const GetCompletedName = (event) => {
        var word = event.target.value;
        if(event.target.value == "")
            getEmployees();
        else{
            var test = completedEmployees.filter(e => e.employeeName.includes(word) || e.employeeNumber.toString().startsWith(word) || e.employeeName.toLowerCase().includes(word));
            setCompletedFilteredEmployees(test);
        }
    }

    const GetActiveName = (event) => {
        var word = event.target.value;
        if(event.target.value == ""){
            getEmployees();
            
        }
        else{
            var test = activeEmployees.filter(e => e.firstName.concat(" ", e.lastName).includes(word) || e.employeeNumber.toString().startsWith(word) || e.firstName.concat(" ", e.lastName).toLowerCase().includes(word));
            setActiveFilteredEmployees(test);
        }
    }

    return ( 
        <>
            <h3>Open Enrollment Report</h3>
            {percentComplete ?
            <h4>Percent of Employees Who Have Completed Open Enrollments: {percentComplete}%</h4>:
            <h4>Percent of Employees Who Have Completed Open Enrollments: </h4>}     
            <h4>Number of Completed Enrollments: {numberComplete}</h4>
            
    <div>
    </div>          
    <Tabs label="enrollments reports">
        <Tab label="Completed">
        <TextInput
            labelText = ""
            placeholder = "search by name or employee ID"
            onChange = {GetCompletedName}
        />
        <h4>List of Employees Who Have Completed Open Enrollment:</h4>
      {completedFilteredEmployees?
    <Table size="lg" useZebraStyles={false}>
      <TableHead>
        <TableRow>
          {completedHeaders.map((header) => (<TableHeader id={header.key} key={header}>
              {header}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
            <TableBody width>
                {completedFilteredEmployees.map((employee) => (
                    <TableRow>
                        <TableCell>{employee.employeeName}</TableCell>
                        <TableCell>{employee.employeeNumber}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
    </Table>
    :<></>}

    </Tab>
    <Tab label="Active">
        <TextInput
            labelText = ""
            placeholder = "search by name or employee ID"
            onChange = {GetActiveName}
        />
        <h4>List of Active Employees:</h4>
      {activeFilteredEmployees?
    <Table size="lg" useZebraStyles={false}>
      <TableHead>
        <TableRow>
          {activeHeaders.map((header) => (<TableHeader id={header.key} key={header}>
              {header}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
            <TableBody width>
                {activeFilteredEmployees.map((employee) => (
                    <TableRow>
                        <TableCell>{employee.firstName} {employee.lastName}</TableCell>
                        <TableCell>{employee.employeeNumber}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
    </Table>
    :<></>}
    </Tab>
    </Tabs>
</>
  );
}
 
export default OpenEnrollmentList;